/**
 * Returns date in ISO format ('yyyy-mm-dd').
 *
 * @example
 * ```js
 * getISODateString(new Date('2024-06-17')); // '2024-06-17'
 * ```
 */
export function getISODateString(date: Date) {
  return date.toISOString().split('T')[0];
}

export function getISODateAndTimeString(date: Date) {
  const formattedDate = date.toISOString().split('T')[0];
  const formattedTime = date.toLocaleTimeString('en-UK', { hour12: false });

  return `${formattedDate} ${formattedTime}`;
}

/**
 * Returns date in ISO format ('yyyy-mm-dd'). but with the current timezone
 *
 * @example
 * ```js
 * getISOLocalString(new Date('2024-06-17')); // '2024-06-17'
 * ```
 */
export function getISOLocalString(date: Date) {
  return date.toLocaleString('sv', { timeZoneName: 'short' }).split(' ')[0];
}

/**
 * Returns date in Oracle format ('DD-MMM-YY').
 * @param date
 */
export function getFormattedDateOracle(date: Date) {
  const months = [
    'JAN',
    'FEB',
    'MAR',
    'APR',
    'MAY',
    'JUN',
    'JUL',
    'AUG',
    'SEP',
    'OCT',
    'NOV',
    'DEC',
  ];
  const day = String(date.getDate()).padStart(2, '0');
  const month = months[date.getMonth()];
  const year = String(date.getFullYear()).slice(-2);
  return `${day}-${month}-${year}`;
}

/**
 * Returns date in Oracle format ('DD-MMM-YY HH:MM:SS').
 * @param date
 */
export function getFormattedDateTimeOracle(date: Date) {
  const formattedDate = getFormattedDateOracle(date);
  const formattedTime = date.toLocaleTimeString('en-uk', { hour12: true });
  return `${formattedDate} ${formattedTime}`;
}
